import React from "react";

export interface PhoneIconProps {
  width?: number;
  height?: number;
  color?: string;
}

const Phone: React.FC<PhoneIconProps> = ({ width = 14, height = 14, color = "#9A9AB0" }) => {
  return (
    <svg width={width} height={height} viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clip-path="url(#clip0_15148_19168)">
        <path
          d="M7.00006 3.49978V7.00006L9.33358 8.16682M12.8339 7.00006C12.8339 10.222 10.222 12.8339 7.00006 12.8339C3.77814 12.8339 1.16626 10.222 1.16626 7.00006C1.16626 3.77814 3.77814 1.16626 7.00006 1.16626C10.222 1.16626 12.8339 3.77814 12.8339 7.00006Z"
          stroke={color}
          stroke-width="2"
          stroke-linecap="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_15148_19168">
          <rect width="14" height="14" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default Phone;
